export default "__VITE_ASSET__853ec264__"